// extracted by mini-css-extract-plugin
export var page = "other-module--page--b+6Qp";
export var page__content = "other-module--page__content--x0GeP";
export var page__desc = "other-module--page__desc--WNot-";
export var page__details = "other-module--page__details--ANjsI";
export var page__title = "other-module--page__title--mh7vq";